// Simplified analytics without Redux toolkit
import axios from "axios";
import { getSeries } from "./LineChart.jsx";

export const postAnalytics = (caseId, type, data, facingType) => {
  if(!type || type === "") return;
  // Get facingType from sessionStorage if not provided (patient-facing pages store it)
  const storedFacingType = facingType || sessionStorage.getItem('facingType') || 'gi';
  return axios.post("/api/user/userAction", { caseId, type, data, facingType: storedFacingType })
    .then(res => console.log('postAnalytics success:', { caseId, type, status: res.status }))
    .catch(err => console.error('postAnalytics error:', { caseId, type, status: err?.response?.status, data: err?.response?.data }));
};

export const postAnalyticsVideo = (userId, data) => {
  axios.post("/api/user/userVideoAction", {
    UserId: userId,
    type: "watched-video",
    data: data, // { percentage, location }
  });
}

export const getTotal = async () => {
  try {
    // Placeholder for analytics data
    return { total: 0 };
  } catch (e) {
    console.error('Analytics error:', e);
    return { total: 0 };
  }
};

export const getTotalWithRange = async (startDate, endDate, dateType, proc) => {
  try {
    // Placeholder for range analytics
    return { 
      sum: 0, 
      series: getSeries([]) 
    };
  } catch (e) {
    console.error('Range analytics error:', e);
    return { 
      sum: 0, 
      series: getSeries([]) 
    };
  }
};

export const getVideoAnalytics = async () => {
  try {
    return [];
  } catch (e) {
    console.error('Video analytics error:', e);
    return [];
  }
};

export const getDepartmentsAnalytics = async () => {
  try {
    return [];
  } catch (e) {
    console.error('Departments analytics error:', e);
    return [];
  }
};

// Helper function for date conversion
const getDateUTC = (date, hour) => {
  const d = new Date(date);
  d.setHours(hour, 0, 0, 0);
  return d.toISOString();
};

// Default export for compatibility
const analytics = {
  postAnalytics,
  getTotal,
  getTotalWithRange,
  getVideoAnalytics,
  getDepartmentsAnalytics
};

export default analytics;